"use strict";
exports.__esModule = true;
exports.SimpleDateFormat = void 0;
var MillenniumDate_1 = require("./MillenniumDate");
var MillenniumWeek_1 = require("./MillenniumWeek");
var SimpleDateFormat = /** @class */ (function () {
    function SimpleDateFormat() {
    }
    SimpleDateFormat.formatToken = function (aDate, token, isWeekFormat) {
        if (isWeekFormat === void 0) { isWeekFormat = false; }
        if (isWeekFormat && ["j", "y", "N", "M", "b", "d"].indexOf(token[0]) !== -1) {
            aDate = new MillenniumWeek_1.MillenniumWeek(aDate, SimpleDateFormat.firstDayOfWeek, SimpleDateFormat.daysInFirstWeek).getDateForWeekday(SimpleDateFormat.firstDayOfWeek);
        }
        switch (token) {
            // y Year
            case "jjjj":
            case "yyyy":
                return aDate.getYear();
            case "jj":
            case "yy":
                return "".concat(aDate.getYear()).substring(2);
            // M Month in year
            case "NNNN":
            case "MMMM":
                return SimpleDateFormat.months[aDate.getMonth()];
            case "NNN":
            case "MMM":
                return SimpleDateFormat.months_short[aDate.getMonth()];
            case "NN":
            case "MM":
                return addZero(aDate.getMonth() + 1);
            case "N":
            case "M":
                return aDate.getMonth() + 1;
            // d Day in month
            case "bb":
            case "dd":
                return addZero(aDate.getDate());
            case "b":
            case "d":
                return aDate.getDate();
            // E Day in week
            case "LLLL":
            case "EEEE":
                return SimpleDateFormat.days[aDate.getDay()];
            case "LLL":
            case "EEE":
                return SimpleDateFormat.days[aDate.getDay()].substring(0, 3);
            case "LL":
            case "EE":
                return SimpleDateFormat.days[aDate.getDay()].substring(0, 2);
            case "L":
            case "E":
                return SimpleDateFormat.days[aDate.getDay()].substring(0, 1);
            // Y Year for week
            case "JJJJ":
            case "YYYY":
                return aDate.getWeekYear(SimpleDateFormat.firstDayOfWeek, SimpleDateFormat.daysInFirstWeek);
            case "JJ":
            case "YY":
            case "J":
            case "Y":
                return "".concat(aDate.getWeekYear(SimpleDateFormat.firstDayOfWeek, SimpleDateFormat.daysInFirstWeek)).substring(2);
            // w Week in year
            case "vv":
            case "ww":
                return addZero(aDate.getWeek(false, SimpleDateFormat.firstDayOfWeek, SimpleDateFormat.daysInFirstWeek));
            case "v":
            case "w":
                return aDate.getWeek(false, SimpleDateFormat.firstDayOfWeek, SimpleDateFormat.daysInFirstWeek);
            // a Am/pm marker
            case "a":
                return aDate.getHours() >= 12 ? "PM" : "AM";
            // H Hour in day (0-23)
            case "HH":
                return addZero(aDate.getHours());
            case "H":
                return aDate.getHours();
            // k Hour in day (1-24)
            case "kk":
                return addZero(aDate.getHours() + 1);
            case "k":
                return aDate.getHours() + 1;
            // K Hour in am/pm (0-11)
            case "KK":
                return addZero(aDate.getHours() % 12);
            case "K":
                return aDate.getHours() % 12;
            // h Hour in am/pm (1-12)
            case "hh":
                var hours = aDate.getHours() % 12;
                return addZero(hours === 0 ? 12 : hours);
            case "h":
                var hrs = aDate.getHours() % 12;
                return hrs === 0 ? 12 : hrs;
            // e End hour in day (0-24)
            case "ee":
                return isMidnight(aDate) ? "24" : addZero(aDate.getHours());
            case "e":
                return isMidnight(aDate) ? "24" : aDate.getHours();
            // m Minute in hour
            case "mm":
                return addZero(aDate.getMinutes());
            case "m":
                return aDate.getMinutes();
            // s Second in minute
            case "ss":
                return addZero(aDate.getSeconds());
            case "s":
                return aDate.getSeconds();
        }
        throw new Error("".concat(token, " is not a valid token."));
    };
    SimpleDateFormat.setLocale = function (locale) {
        SimpleDateFormat.months = [
            "a_january",
            "b_february",
            "c_march",
            "d_april",
            "e_may",
            "f_june",
            "g_july",
            "h_august",
            "i_september",
            "j_october",
            "k_november",
            "l_december",
        ].map(function (key) { return locale.get("zz_month_".concat(key)).toLowerCase(); });
        SimpleDateFormat.months_short = [
            "a_january",
            "b_february",
            "c_march",
            "d_april",
            "e_may",
            "f_june",
            "g_july",
            "h_august",
            "i_september",
            "j_october",
            "k_november",
            "l_december",
        ].map(function (key) { return locale.get("zz_month_".concat(key, "_short")).toLowerCase(); });
        SimpleDateFormat.days = [
            "a_sunday",
            "b_monday",
            "c_tuesday",
            "d_wednesday",
            "e_thursday",
            "f_friday",
            "g_saturday",
        ].map(function (key) { return locale.get("zz_weekday_".concat(key)).toLowerCase(); });
        SimpleDateFormat.firstDayOfWeek = locale.firstDayOfWeek;
        SimpleDateFormat.daysInFirstWeek = locale.daysInFirstWeek;
    };
    SimpleDateFormat.months = [
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december",
    ];
    SimpleDateFormat.months_short = [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec",
    ];
    SimpleDateFormat.days = ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"];
    SimpleDateFormat.firstDayOfWeek = null;
    SimpleDateFormat.daysInFirstWeek = null;
    SimpleDateFormat.format = function (aDate, format) {
        var _a;
        if (containsEndDate(format)) {
            if (isMidnight(aDate)) {
                aDate = (_a = aDate.addDays) === null || _a === void 0 ? void 0 : _a.call(aDate, -1);
            }
        }
        var isWeekFormat = format.indexOf("w") !== -1;
        return getTokens(format).reduce(function (output, token) {
            if (token.type === "literal") {
                return output + token.value;
            }
            return output + SimpleDateFormat.formatToken(aDate, token.value, isWeekFormat);
        }, "");
    };
    return SimpleDateFormat;
}());
exports.SimpleDateFormat = SimpleDateFormat;
var addZero = function (number) {
    if (number < 10) {
        return "0".concat(number.toString());
    }
    return number;
};
var isMidnight = function (date) {
    if (date instanceof MillenniumDate_1.MillenniumDate) {
        return false;
    }
    return date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0;
};
var getTokens = function (input) {
    var patterns = "yMdEYwaHkKhemsjNbLJve";
    var escaped = false;
    var output = [];
    var lastCharacter = "";
    var currentToken = "";
    var i = 0;
    while (i < input.length) {
        var character = input.substring(i, i + 1);
        if (character === "'") {
            escaped = !escaped;
        }
        else if (!escaped && patterns.indexOf(character) !== -1) {
            if (currentToken && lastCharacter && lastCharacter !== character) {
                output.push({ type: "token", value: currentToken });
                currentToken = "";
            }
            currentToken = currentToken.concat(character);
        }
        else {
            if (currentToken) {
                output.push({ type: "token", value: currentToken });
                currentToken = "";
            }
            output.push({ type: "literal", value: character });
        }
        lastCharacter = character;
        i++;
    }
    if (currentToken) {
        output.push({ type: "token", value: currentToken });
    }
    return output;
};
var endDateTokens = [
    "jjjj",
    "jj",
    "NNNN",
    "NNN",
    "NN",
    "N",
    "bb",
    "b",
    "LLLL",
    "LLL",
    "LL",
    "L",
    "JJJJ",
    "JJ",
    "J",
    "vv",
    "v",
    "ee",
    "e",
];
var containsEndDate = function (format) {
    var tokens = getTokens(format)
        .filter(function (item) { return item.type === "token"; })
        .map(function (item) { return item.value; });
    return tokens.some(function (token) { return endDateTokens.indexOf(token) !== -1; });
};
